<template>
  <div>
    <div class="sync-management-no-crm">
      <h2 class="sync-management-no-crm__heading">You haven’t connected your CRM yet</h2>
      <div class="sync-management-no-crm__text">
        <p>
          Connecting your CRM account allows for syncing of fata after connection is successful. Please visit
          <strong>Integrations</strong> to find and connect to available CRMs. <br />
          <a href="#" class="sync-management-no-crm__link">Learn more about CRM syncing.</a>
        </p>
        <a href="/integrations/catalogue" class="btn btn-lg btn-primary sync-management-no-crm__button"
          >Go to Integrations</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sync-management-no-crm',
};
</script>

<style lang="scss" scoped>
@import '../../../sass/web/_variables.scss';

.sync-management-no-crm {
  text-align: center;
  &__img,
  &__text {
    margin: 0 auto;
  }
  &__text {
    max-width: 765px;
    font-size: 24px;
    line-height: 32px;
  }
  &__link {
    color: $half-baked-color;
    font-weight: bold;
    text-decoration: underline;
  }
  &__button {
    font-weight: 700;
  }
}
</style>
